// The times offered by the picker: every quarter hour of the day, keyed as
// "HH:mm" in local time.

export const TIME_STEP_MINUTES = 15;

const pad = (n: number) => String(n).padStart(2, '0');

export const toTimeKey = (date: Date): string =>
  `${pad(date.getHours())}:${pad(date.getMinutes())}`;

// The same day at the time of a key.
export const withTimeKey = (base: Date, key: string): Date => {
  const match = /^(\d{2}):(\d{2})$/.exec(key);
  if (!match) {
    return base;
  }
  const next = new Date(base);
  next.setHours(Number(match[1]), Number(match[2]), 0, 0);
  return next;
};

// Every quarter hour of the given day, in order.
export const timeSlots = (day: Date): Date[] => {
  const slots: Date[] = [];
  for (let minutes = 0; minutes < 24 * 60; minutes += TIME_STEP_MINUTES) {
    const slot = new Date(day);
    slot.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);
    slots.push(slot);
  }
  return slots;
};

// The next quarter hour at or after the given time, so a fresh event
// starts on a round time instead of "21:52".
export const roundUpToSlot = (date: Date): Date => {
  const rounded = new Date(date);
  rounded.setSeconds(0, 0);
  const over = rounded.getMinutes() % TIME_STEP_MINUTES;
  if (over !== 0) {
    rounded.setMinutes(rounded.getMinutes() + TIME_STEP_MINUTES - over);
  }
  return rounded;
};
